import type {GoalModel} from '../../../domain/Goal/Goal.model';

export abstract class FetchUnboundGoalsQuery {
  abstract exec(
    props: FetchUnboundGoalsQuery.Props,
  ): Promise<FetchUnboundGoalsQuery.Response>;
}

export namespace FetchUnboundGoalsQuery {
  export type Props = {
    courseId?: string;
    excludeProgramId?: string;
    programId?: string;
    statuses?: GoalModel.Status[];
    withCourseId?: boolean;
  };
  export type Response = GoalModel[];
}
